/*
     Title: Panel Check API
     Description: Panel Check API
     Author: Iqbal Hossain
     Date: 22-January-2022
     Modified: 22-January-2022
*/

export const PANEL_CHECK_API = {
  root: '/api/panel-check',
  fetch_all: 'api/panel-check/fetch-all',
  fetch_by_query: `/api/panel-check/fetch-by-query`,
  fetch_by_id: `/api/panel-check/fetch-by-id`
};
